import { CryptoContext } from '../base';
import { NanoDataConfigDumpArgs, NanoDataConfigLoadArgs } from './args';
import { NanoDataConfigV1 } from './v1';
import { CU_BASE } from '../feature';

export let NANO_DATA_CRYPTO_CONTEXT = new CryptoContext<
  NanoDataConfigLoadArgs,
  NanoDataConfigDumpArgs
>([new NanoDataConfigV1(CU_BASE)]);
